import { cn } from '@/utils/styles/cn'
import { LANDING_PAGE_SECTION_PADDING } from '@/features/landing-page/helpers/landing-page-constants'
import { type ReactNode } from 'react'

interface ILandingPageSectionContainerProps {
    children: ReactNode
    className?: string
    id?: string
}

export function LandingPageSectionContainer({ children, className, id }: ILandingPageSectionContainerProps) {
    return (
        <section id={id} className={cn('w-full', LANDING_PAGE_SECTION_PADDING, className)}>
            {children}
        </section>
    )
}
